export { default as VictoryTooltip } from "./victory-tooltip";
export { default as Flyout } from "./flyout";


//////////////////
// WEBPACK FOOTER
// ./~/victory-tooltip/es/index.js
// module id = 963
// module chunks = 0